const normalizeEmployeeId = (userProfile = {}) => (
  userProfile?.employeeId
  ?? userProfile?.employee_id
  ?? userProfile?.emp_id
  ?? userProfile?.empId
  ?? ''
);

const normalizePermissionMap = (permissions = {}) => {
  const permissionMap = permissions && typeof permissions === 'object' ? permissions : {};
  const nextPermissions = { ...permissionMap };

  Object.entries(permissionMap).forEach(([moduleName, actions]) => {
    if (!moduleName) return;
    const hyphenKey = String(moduleName).replace(/_/g, '-');
    const underscoreKey = String(moduleName).replace(/-/g, '_');
    if (!Object.prototype.hasOwnProperty.call(nextPermissions, hyphenKey)) {
      nextPermissions[hyphenKey] = actions;
    }
    if (!Object.prototype.hasOwnProperty.call(nextPermissions, underscoreKey)) {
      nextPermissions[underscoreKey] = actions;
    }
  });

  return nextPermissions;
};

const buildEmployeeCostUserInfo = (userProfile = {}) => {
  const employeeId = normalizeEmployeeId(userProfile);
  const email = userProfile?.email || userProfile?.email_id || userProfile?.login_id || userProfile?.loginId || '';

  return {
    emailId: email,
    email,
    login_id: userProfile?.login_id || email,
    permissions: normalizePermissionMap(userProfile?.permissions),
    roleDetails: Array.isArray(userProfile?.roleDetails) ? userProfile.roleDetails : [],
    employeeId,
    employee_id: employeeId,
    emp_id: employeeId,
    empId: employeeId,
    globalColors: userProfile?.siteConfiguration?.global_colors,
  };
};

export {
  normalizeEmployeeId,
  buildEmployeeCostUserInfo,
};
